import Mixpanel from 'common/services/stats/-RFC.Mixpanel';

const _directiveDependencies = [];
const _controllerDependencies = ['$scope', '$rootScope', 'Util'];

class CmaDisclaimerController {

    constructor($scope, $rootScope, Util) {

        // CMA Links
        const currentLanguage = CWCONFIG.language;
        const configSupportLanguages = CWCONFIG.cma.subscriptions.supportLanguages;
        let redirectSupportLanguage = '';

        if (configSupportLanguages.find(lang => lang === currentLanguage)) {

            if (currentLanguage === 'en') {

                redirectSupportLanguage = 'en-us';

            } else {

                redirectSupportLanguage = currentLanguage;

            }

        } else {

            redirectSupportLanguage = 'en-us';

        }

        $scope.siteLink = CWCONFIG.cma.subscriptions.siteLink.replace(/\[language\]/gi, currentLanguage);
        $scope.globalPrivacy = CWCONFIG.cma.subscriptions.globalPrivacy.replace(/\[language\]/gi, currentLanguage);
        $scope.termsOfSale = CWCONFIG.cma.subscriptions.termsOfSale.replace(/\[language\]/gi, currentLanguage);
        $scope.licenseAgreement = CWCONFIG.cma.subscriptions.licenseAgreement.replace(/\[language\]/gi, currentLanguage);
        $scope.cancellation = CWCONFIG.cma.subscriptions.tooltip.cancellationPolicy.replace(/\[language\]/gi, currentLanguage);
        $scope.contactUs = CWCONFIG.cma.subscriptions.tooltip.contactUs.replace(/\[language\]/gi, redirectSupportLanguage);
        $scope.learnHow = CWCONFIG.cma.subscriptions.learnHow.replace(/\[language\]/gi, currentLanguage);
        $scope.cancelOrRefund = CWCONFIG.cma.subscriptions.cancelOrRefund.replace(/\[language\]/gi, currentLanguage);
        $scope.yourAccount = CWCONFIG.cma.subscriptions.yourAccount.replace(/\[language\]/gi, currentLanguage);
        $scope.cancelContractDetails = CWCONFIG.cma.subscriptions.cancelContractDetails.replace(/\[language\]/gi, redirectSupportLanguage);
        $scope.cancelContractDetailsNew = CWCONFIG.cma.subscriptions.cancelContractDetailsNew.replace(/\[language\]/gi, redirectSupportLanguage);
        const displang3 = Util.getIso3LangCode(currentLanguage);
        const displocale3 = Util.getIso3CountryCode($rootScope.accountCountry, displang3);
        $scope.euWithdrawFromContract = CWCONFIG.cma.subscriptions.euWithdrawFromContract
            .replace('[displang3]', displang3)
            .replace('[displocale3]', displocale3);
        // End CMA links

        $scope.trackEuWithdrawClick = function trackEuWithdrawClick($event) {

            if ($event.target && $event.target.tagName.toLowerCase() === 'a') {

                Mixpanel.send('ConnectWeb EU Withdraw From Contract Click');

            }

        };

        $rootScope.cmaDisclaimerHeight = { 'padding-bottom': `${angular.element('.bottom-page-notification').outerHeight() + 8}px` };

    }

}


class CmaDisclaimerDirective {

    constructor() {

        this.template = require('./cma-disclaimer.html');
        this.restrict = 'EA';
        this.replace = true;

        _controllerDependencies.push(($scope, $rootScope, Util) =>
            new CmaDisclaimerController($scope, $rootScope, Util));
        this.controller = _controllerDependencies;
        this.controllerAs = 'cmaDisclaimerCtrl';

    }

}

_directiveDependencies.push(() => new CmaDisclaimerDirective());


angular.module('directives')
    .directive('cmaDisclaimer', _directiveDependencies);



// WEBPACK FOOTER //
// ./scripts/directives/dashboard/cma-disclaimer/cma-disclaimer.js